import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { NgModule } from '@angular/core';

import { ResetPasswordPage } from './resetPassword';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, MatCardModule, MatInputModule, MatTabsModule],
  declarations: [ResetPasswordPage]
})
export class ResetPasswordPageModule {}
